import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';

import styles from './SearchResultsEmpty.module.scss';

export const SearchResultsEmpty: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleExploreCatalog = () => {
    navigate('/shop');
  };

  return (
    <div className={styles.emptyState}>
      <div className={styles.iconWrapper}>
        <img
          src={company.images.search.empty}
          className={styles.emptyStateIcon}
          alt=""
        />
      </div>
      <h3 className={styles.emptyStateTitle}>
        {t('header:cantFindWhatYouAreLookingFor')}
      </h3>
      <Button
        variant="primary"
        size="L"
        endIcon="chevron-3.1"
        iconSize={11}
        className={styles.exploreCatalogButton}
        onClick={handleExploreCatalog}
      >
        {t('header:exploreOurCatalog')}
      </Button>
    </div>
  );
};
